import React from 'react';
import { ReactComponent as Spinner } from '../../assets/icons/spinner.svg';

const Loading = ({ text = 'Loading...' }) => {
  return (
    <div className="loading-screen">
      <div className="spinner">
        <Spinner />
        <p>{text}</p>
      </div>
    </div>
  );
};

export default Loading;
